import { IconButton, Modal as ChakraModal, ModalOverlay } from "@chakra-ui/react";
import { useEffect } from "react";
import { CustomModalBody, CustomModalContent } from "./modal.style";
import { type CustomModalProps } from "./modal.type";

export const Modal = ({ children, iconName, isOpen, onClose, ...rest }: CustomModalProps) => {
    useEffect(() => {
        if (isOpen) {
            const timeoutId = setTimeout(() => {
                const container = document.querySelector(".chakra-modal__content-container") as HTMLElement;
                if (container) {
                    container.style.zIndex = "10000";
                }
            }, 0);

            return () => clearTimeout(timeoutId);
        }

        return () => {};
    }, [isOpen]);

    return (
        <ChakraModal isOpen={isOpen} onClose={onClose} {...rest}>
            <ModalOverlay />
            <CustomModalContent>
                {iconName && (
                    <IconButton
                        aria-label="Close modal"
                        icon={<span className="material-icons">{iconName}</span>}
                        position="absolute"
                        zIndex="9998"
                        top="1rem"
                        right="1rem"
                        onClick={onClose}
                    />
                )}
                <CustomModalBody>{children}</CustomModalBody>
            </CustomModalContent>
        </ChakraModal>
    );
};
